import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import {
    BulkRestoreError,
    BulkRestorePartialError,
    UnderfrequencyEventService,
    UnderfrequencyPayload,
} from '../../../services/underfrequency-event.service';

@Component({
    standalone: false,
    selector: 'app-underfrequency-bulk-restore-modal',
    templateUrl: './underfrequency-bulk-restore-modal.component.pug',
    styleUrls: ['./underfrequency-bulk-restore-modal.component.scss'],
})
export class UnderfrequencyBulkRestoreModal {

    constructor(
        public dialogRef: MatDialogRef<UnderfrequencyBulkRestoreModal>,
        @Inject(MAT_DIALOG_DATA) public rows: UnderfrequencyPayload[],
        private underfrequencyService: UnderfrequencyEventService,
    ) {}

    passwordEntered: string = '';
    loading: boolean = false;
    partialErrors: { nodeId: string; label: string; error: string }[] = [];

    closeModal(): void {
        this.dialogRef.close();
    }

    checkPassword(ev: Event): void {
        this.passwordEntered = (ev.target as HTMLInputElement).value;
    }

    async confirm(): Promise<void> {
        this.loading = true;
        this.partialErrors = [];

        const eventNodeIds = this.rows.map(r => r.event_node_id).filter(Boolean);

        try {
            await this.underfrequencyService.bulkRestore(eventNodeIds);
            this.dialogRef.close({ success: true });
        } catch (err) {
            if (err instanceof BulkRestoreError) {
                this.partialErrors = this.buildPartialErrors(err.errors);
            } else if (err instanceof HttpErrorResponse) {
                this.partialErrors = [{ nodeId: '', label: '', error: err.error?.message || err.message || 'An unexpected error occurred' }];
            } else {
                this.partialErrors = [{ nodeId: '', label: '', error: 'An unexpected error occurred' }];
            }
        } finally {
            this.loading = false;
        }
    }

    private buildPartialErrors(errors: { [nodeId: string]: BulkRestorePartialError }) {
        return Object.entries(errors).map(([nodeId, e]) => ({
            nodeId,
            label: e.registration_set_display_label,
            error: e.error,
        }));
    }
}
